/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'

import { Box } from '@mui/material'
import CommonBarChart from 'components/Chart/AIMetricOvertime/BarChart'
import getDataAIMetricOT, { getFirstAndLastYear } from 'utils/getDataAIMetricsOT'
import { useActions, useAppSelector } from 'hooks'
import { inputFilter, ranking } from 'store/AIMetricOT/reducerSlice'
import { getCountryNameFromCountryLongCode, useDataWithMetric } from 'utils'
import { DATA_FILE_NAME, DATA_FILE_PATH, DOWNLOAD_FILE_NAME } from 'constant'
import DownloadImages from 'components/common/Download/DownloadImages'
import { useImageDownload } from 'components/common/Download/useImageDownload'
import { DownloadType } from 'types'
import ChartHeader from 'components/common/ChartHeader/ChartHeader'
import { getMetricByKey } from 'utils/getMetricListByType'
import { getAllMetricsFromGroups } from 'utils/getAllMetricsFromGroups'
import Papa from 'papaparse'

export default function AIMetricOT() {
  const { data, loading, error } = useDataWithMetric(`${DATA_FILE_PATH}${DATA_FILE_NAME}.csv`)
  const currentFilter = useAppSelector(inputFilter)
  const currentRanking = useAppSelector(ranking)
  const isGlobal = currentFilter.countryType === 'global'
  const metricDataTypeMap = useAppSelector(({ vibrancy }: any) => vibrancy.metricDataTypeMap)
  const multiSelectedCountries = useAppSelector(({ AIMetric }: any) => AIMetric.multiSelectedCountries)
  const [csvData, setCsvData] = useState<any[] | null>(null)

  useEffect(() => {
    if (data && !loading && !error) {
      setCsvData(data)
    }
  }, [data, loading, error])

  // const [csvData, setCsvData] = useState<any[] | null>(null)

  // const fetchCsvData = async (path: string) => {
  //   const response = await fetch(path)
  //   const reader = response.body?.getReader()
  //   const result = await reader?.read()
  //   const decoder = new TextDecoder('utf-8')
  //   const csv = decoder.decode(result?.value)
  //   const results = Papa.parse(csv, { header: true })
  //   return results.data
  // }

  // useEffect(() => {
  //   if (!csvData) {
  //     fetchCsvData(`${DATA_FILE_PATH}${DATA_FILE_NAME}.csv`).then((data) => {
  //       setCsvData(data)
  //     })
  //   }
  // }, [csvData])

  const dataAIMetricOT = useMemo(() => {
    return getDataAIMetricOT({
      ranking: currentRanking,
      country: currentFilter.country,
      countryType: currentFilter.countryType,
      metric: currentFilter.metric,
      metricType: currentFilter.metricType,
      metricValue: currentFilter.metricValue,
      chartType: currentFilter.chartType,
      worldmapYear: currentFilter.worldmapYear,
      multiSelectedCountries: multiSelectedCountries,
      data: csvData,
    })
  }, [
    currentRanking,
    currentFilter.country,
    currentFilter.countryType,
    currentFilter.metric,
    currentFilter.metricType,
    currentFilter.metricValue,
    currentFilter.chartType,
    csvData,
  ])
  const fullCountryData = useAppSelector(({ vibrancy }) => vibrancy.fullCountryData)
  const countryName = getCountryNameFromCountryLongCode(fullCountryData, currentFilter.country)
  const metricGroups = useAppSelector(({ vibrancy }) => vibrancy.metricGroup)
  const allMetrics = getAllMetricsFromGroups(metricGroups)
  const getMetricName = getMetricByKey(
    allMetrics,
    (currentFilter.metric as Record<string, any>)[currentFilter.metricType]?.[currentFilter.metricValue],
  )

  const metricDetails = useMemo(() => {
    const allDetailedMetrics: any = []
    metricGroups.forEach((group: any) => {
      if (group?.metrics?.length) {
        allDetailedMetrics.push(...group?.metrics)
      }
    })
    const metricObj = currentFilter.metric as Record<string, any>
    const shortName =
      metricObj[currentFilter.metricType] && metricObj[currentFilter.metricType][currentFilter.metricValue]
    const findMetric = allDetailedMetrics.find((m: any) => {
      return m.shortname_raw === shortName && m?.metricValue === currentFilter.metricValue
    })
    return findMetric
  }, [metricGroups, currentFilter])

  const showPercentage = useMemo(() => {
    return metricDataTypeMap[metricDetails?.shortname_raw] === 'Percentage'
  }, [metricDataTypeMap, metricDetails])

  const convertedData = useMemo(() => {
    if (!showPercentage) return dataAIMetricOT
    return dataAIMetricOT?.map((ele) => ({
      ...ele,
      value: ele.value * 100,
    }))
  }, [showPercentage, dataAIMetricOT])

  const vendorName = useMemo(() => {
    return metricDetails?.source
  }, [metricDetails])

  const currentYearHaveData = getFirstAndLastYear(dataAIMetricOT)
  const yearDataRender = () => {
    if (currentYearHaveData?.firstYear === currentYearHaveData?.lastYear) {
      return `${currentYearHaveData?.firstYear || 2024}`
    }
    return `${currentYearHaveData?.firstYear || 2017}–${currentYearHaveData?.lastYear || 2024}`
  }
  // Download images
  const fileNameDownload = DOWNLOAD_FILE_NAME.aiMetricOverTime
  const [clickDownload, setClickDownload] = useState<DownloadType>(null)
  const { handleCallDownload, divRef } = useImageDownload()
  const { setCountry, setShowDwnLoader } = useActions()
  const handleDivDownload = (type: DownloadType) => {
    setShowDwnLoader(true)
    setClickDownload(type)
  }
  useEffect(() => {
    if (clickDownload) {
      handleCallDownload(clickDownload, {
        fileName: fileNameDownload,
        orientation: 'landscape',
        isSquareDownload: true,
      })
      setClickDownload(null)
    }
  }, [clickDownload])

  // useEffect(() => {
  //   const isAdhocCountrySelected = fullCountryData.find(
  //     (el) => el.countryLongCode === currentFilter.country,
  //   )?.isAdhocCountry
  //   if (isAdhocCountrySelected) {
  //     return () => {
  //       const debouncedCountryUpdate = getDebouncedDispatcher(setCountry)
  //       debouncedCountryUpdate({ country: 'USA' })
  //     }
  //   }
  // }, [currentFilter.country])

  // const vendorName = 'CSET'
  const yearSource = new Date().getFullYear()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative' }}>
      {getMetricName ? (
        <DownloadImages
          handleDownPNG={() => handleDivDownload('png')}
          handleDownJPG={() => handleDivDownload('jpg')}
          handleDownPDF={() => handleDivDownload('pdf')}
        />
      ) : null}
      <Box sx={{ padding: '24px' }}>
        <Box
          sx={{
            marginBottom: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <ChartHeader
            header1={
              getMetricName
                ? `${getMetricName}${currentFilter.metricValue === 'perCapita' ? ' Per Capita' : ''}${!isGlobal ? ` for ${countryName}` : ''
                }, ${yearDataRender()}`
                : 'No data available'
            }
            header2={getMetricName ? `Source: ${vendorName} | Chart: AI Index, ${yearSource}` : ''}
          />
        </Box>
        {getMetricName ? (
          <CommonBarChart
            showPercentage={showPercentage}
            // data={dataAIMetricOT}
            data={convertedData}
            isGrid={true}
            gridBackground={'#fff'}
            gridColor={'#dadada'}
            isTickLine={false}
            height={500}
            barWidth={70}
            barColor={'#4e82b8'}
            activeBarColor={'#4993c7'}
            tickColor={'#000'}
            axisFontSize={14}
            tickCount={10}
          />
        ) : null}
      </Box>
      {getMetricName ? (
        <Box sx={{ zIndex: -1, position: 'absolute', padding: '24px', minWidth: '1020px' }} ref={divRef}>
          <Box
            sx={{
              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <ChartHeader
              header1={`${getMetricName}${currentFilter.metricValue === 'perCapita' ? ' Per Capita' : ''}${!isGlobal ? ` for ${countryName}` : ''
                }, ${yearDataRender()}`}
              header2={`Source: ${vendorName} | Chart: AI Index, ${yearSource}`}
            />
          </Box>
          <CommonBarChart
            showPercentage={showPercentage}
            // data={dataAIMetricOT}
            data={convertedData}
            isGrid={true}
            gridBackground={'#fff'}
            gridColor={'#dadada'}
            isTickLine={false}
            height={500}
            barWidth={70}
            barColor={'#4e82b8'}
            activeBarColor={'#4993c7'}
            tickColor={'#000'}
            axisFontSize={14}
            tickCount={10}
          />
        </Box>
      ) : null}
    </Box>
  )
}
